module.exports = __webpack_public_path__ + "img/ais-target-heading-r.747f870f.svg";